import React from 'react';
import { Typography } from '@mui/material';

export const GamingSystems = ({ systems }) => {
    if (!systems || systems.length === 0) return null;

    return (
        <div className="details-group">
            <Typography variant="h6" className="section-title">Gaming Systems</Typography>
            <div className="details-grid">
                {systems.map((system, index) => (
                    <Typography key={index} variant="body1">{system.label}</Typography>
                ))}
            </div>
        </div>
    );
};